const semanticClassNames = {
  root: 'slideshow',
} as const;

export default semanticClassNames;
